import { Box, Card, CardContent, Divider, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import CustomPagination from "../../../../../../components/custom-pagination/CustomPagination";
import { AppMisc } from "../../../../../../misc/appMisc";
import { Delete, Edit, Print } from "@mui/icons-material";
import { GENDER_OPTIONS, MUAC_OPTIONS, NO_RECORDS_FOUND } from "../../../../../../utils/constants";
import { API_URL } from "../../../../../../api/api";
import { AppUtils } from "../../../../../../utils/appUtils";
import { getDataFromServer } from "../../../../../../utils/apiUtils";
import ReactToPrint from "react-to-print";

const SwarnaBinduBabaranRegister = ({ totalSize, ...props }) => {
  const [mainRegisterData, setMainRegisterData] = useState([]);
  const tableRef = useRef();
  const id = AppUtils.getUrlParam("id");
  const [cardData, setCardData] = useState([]);
  const printComponentRef = useRef();

  useEffect(() => {
    if (props.tableData !== null) {
      setMainRegisterData(props.tableData);
    }
  }, [props.tableData]);

  const getCardData = async () => {
    let url = API_URL.swarnaBindu + "/" + id
    let response = await getDataFromServer(url)
    if (response) {
      setCardData(response)
    }
  }

  useEffect(() => {
    getCardData()
  }, [])

  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Box display={"flex"} justifyContent={"flex-end"} margin={3}>
            <IconButton>
              <Print />
            </IconButton>
          </Box>
        )}
        content={() => printComponentRef.current}
      />
      <Box ref={printComponentRef}>
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle1">सेवाग्राहीको सामान्य विवरण</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                दर्ता मिति:{AppMisc.getDateLabelFromMillisecond(cardData?.dartaaMiti)}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                नाम:{cardData?.patientFirstName}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                थर:{cardData?.patientLastName}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                उमेर:{cardData?.age && AppUtils.replaceWithNepaliDigit(cardData.age) + "वर्ष"}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                लिङ्ग:{cardData?.gender && AppMisc.findLabelFromValue(GENDER_OPTIONS, cardData.gender)}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                जिल्ला:{cardData?.district && AppMisc.getDistrictName(cardData.district)}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                नगर/गाउँपालिका:{cardData?.palikaName}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                वडा नं:{cardData?.wardNumber && AppUtils.replaceWithNepaliDigit(cardData.wardNumber)}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                टोल:{cardData?.gaunOrTole}
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                सम्पर्क नं.:{cardData?.phoneNumber && AppUtils.replaceWithNepaliDigit(cardData?.phoneNumber)}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <TableContainer classes={{ root: "fixed-head-table-container" }} ref={tableRef}>
          <Table classes={{ root: "table-bordered normal-spacing" }} size="small" aria-label="Swarna Bindu Sewa Bibaran">
            <TableHead classes={{ root: "align-center fixed-header header-sm" }}>
              <TableRow>
                <TableCell>मिति</TableCell>
                <TableCell>सेवा पटक</TableCell>
                <TableCell>मात्रा-थोपामा</TableCell>
                <TableCell>तौल (के.जी.)</TableCell>
                <TableCell>उचाइ (से.मि.)</TableCell>
                <TableCell>MUAC</TableCell>
                <TableCell>फर्केर आउने मिति</TableCell>
                <TableCell className="print-none">सम्पादन</TableCell>
              </TableRow>
            </TableHead>
            <TableBody classes={{ root: "align-center" }}>
              {mainRegisterData?.length > 0 ? (
                mainRegisterData?.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{AppMisc.getDateLabelFromMillisecond(row?.dartaaMiti)}</TableCell>
                    <TableCell>{AppUtils.replaceWithNepaliDigit(index + 1)}</TableCell>
                    <TableCell>{row?.numberOfDrops ? AppUtils.replaceWithNepaliDigit(row.numberOfDrops) : "-"}</TableCell>
                    <TableCell>{row?.weightKg ? AppUtils.replaceWithNepaliDigit(row.weightKg) : "-"}</TableCell>
                    <TableCell>{row?.heightCm ? AppUtils.replaceWithNepaliDigit(row.heightCm) : "-"}</TableCell>
                    <TableCell>{row?.muac ? AppMisc.findLabelFromValue(MUAC_OPTIONS, row.muac) : '-'}</TableCell>
                    <TableCell>{row?.nextVisitDate ? AppMisc.getDateLabelFromMillisecond(row.nextVisitDate) : "-"}</TableCell>
                    <TableCell className="print-none">
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        gap={1}>
                        <IconButton aria-label="edit" onClick={() => props.onEditRow(row.id)}>
                          <Edit fontSize="small" />
                        </IconButton>
                        <Tooltip title="रेकर्ड हटाउन यहा क्लिक गर्नुहोस" placement="top" arrow>
                          <IconButton color="secondary" onClick={() => props.deleteRow(row.id)}>
                            <Delete fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan="9" size="medium">{NO_RECORDS_FOUND}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <CustomPagination count={totalSize} />
    </>
  );
};

export default SwarnaBinduBabaranRegister;